import React, { useState, useEffect } from 'react'
import { Button } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import VerificationCodeInput from '../../common/VerificationCodeInput'
import Actions from '../../../actions'
import $t from '../../../i18n'
import Page from '../../common/Page'
import PageCard from '../../common/PageCard'

import './VerifyPhoneCode.css'
import { event, eventTypes } from '../../../consts/eventConsts'

const VerifyPhoneCode = ({
  loading,
  onNext,
  onResend,
  phone,
  errorMessage,
}) => {
  const dispatch = useDispatch()
  const phoneNumberToVerify = useSelector(
    state => state.profile?.phoneNumberToVerify
  )
  const oneTimeLoginError = useSelector(state => state.auth?.oneTimeLoginError)
  const isPhoneNumbersVerificationLoading = useSelector(
    state => state.profile?.isPhoneNumbersVerificationLoading
  )

  const [code, setCode] = useState('')
  const [enableButton, setEnableButton] = useState(false)

  const phoneNumber = phone || phoneNumberToVerify

  useEffect(() => {
    setTimeout(() => {
      setEnableButton(true)
    }, 10000)
  }, [])

  const resendVerificationCode = () => {
    onResend
      ? onResend(phoneNumber)
      : dispatch(
          Actions.createAction(Actions.PHONE_NUMBER_VERIFICATION_REQUESTED, {
            phoneNumber: phoneNumber,
          })
        )
    setEnableButton(false)
    setTimeout(() => {
      setEnableButton(true)
    }, 10000)
    dispatch(
      Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
        type: eventTypes.click,
        eventName: event.clickEvent.click,
        element: 'Resend verification code',
      })
    )
  }

  const handleNext = () => {
    if (code.length === 6) {
      onNext
        ? onNext({ phoneNumber, code })
        : dispatch(
            Actions.createAction(Actions.PHONE_NUMBER_CODE_VERIFY_REQUESTED, {
              phoneNumber: phoneNumber,
              value: code,
            })
          )
      dispatch(
        Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
          type: eventTypes.formEvent,
          eventName: event.formEvent.submit,
          element: 'Verify phone number',
          data: { phoneNumber, code },
        })
      )
    }
  }

  const getSubtitle = () => {
    return (
      <div className="verify-code-subtitle">
        <div>{$t('pages.getStarted.verifyphone.enterTheCodeSentTo')}</div>
        <div className="semi-bold">{phoneNumber}</div>
      </div>
    )
  }

  return (
    <PageCard className="verify-phone-page-card login-page-card">
      <Page
        className="verify-phone-container login-page"
        title={$t('pages.getStarted.verifyphone.whatsTheCode')}
        subtitle={getSubtitle()}
      >
        <div className="verify-phone-code-input-container">
          <VerificationCodeInput
            className="verify-phone-code-input"
            fields={6}
            onChange={v => {
              setCode(v)
            }}
          />

          <div className="verify-phone-validity-text">
            {$t('pages.getStarted.verifyphone.thisCodeIsValidFor10Minutes', {
              min: 10,
            })}
          </div>
          {enableButton && (
            <div className="verify-phone-didnt-get-code-text-container">
              <span className="didnt-get-code-text">
                {$t('pages.getStarted.verifyphone.didntGetTheCode')}
              </span>
              <button
                data-name="send-again-button"
                className="send-again-button trackable"
                onClick={resendVerificationCode}
              >
                {$t('pages.getStarted.verifyphone.sendAgain')}
              </button>
            </div>
          )}
          <div className="verify-phone-error-message">
            {errorMessage || oneTimeLoginError}
          </div>
        </div>
        <Button
          type="primary"
          data-name="verify-phone-code-next-button"
          className="verify-phone-code-next-button trackable"
          loading={isPhoneNumbersVerificationLoading || loading}
          onClick={handleNext}
        >
          {$t('pages.getStarted.verifyphone.next')}
        </Button>
      </Page>
    </PageCard>
  )
}

export default VerifyPhoneCode
